import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ua",
  "use": "icon-icon-ua-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ua\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"gold\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#0057b8\" d=\"M0 0h512v256H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol